import { render, staticRenderFns } from "./productionRecord.vue?vue&type=template&id=d5eaa0c6&scoped=true"
import script from "./productionRecord.vue?vue&type=script&lang=js"
export * from "./productionRecord.vue?vue&type=script&lang=js"
import style0 from "./productionRecord.vue?vue&type=style&index=0&id=d5eaa0c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5eaa0c6",
  null
  
)

export default component.exports